import 'core-js/features/array/find';
import 'core-js/features/array/flat-map';
import 'core-js/features/array/includes';
import 'core-js/features/array/includes';
import 'core-js/features/array/keys';
import 'core-js/features/map';
import 'core-js/features/object/assign';
import 'core-js/features/object/from-entries';
import 'core-js/features/object/values';
import 'core-js/features/set';
import 'core-js/features/string/repeat';
import 'core-js/features/url-search-params';
import 'setimmediate';
